import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import './App.css'; // Import corresponding CSS for styling


const Service1 = () => {
  // Define the services and their corresponding images
  const services = [
    'Spend the Day - Morning',
    'Spend the Day - Evening',
    'Auvrudu Celebrations',
    'Wedding Events Celebrations',
    'Birthday Party Celebrations',
    'Special Events Celebrations',
    'Co-operate Events',
    'BYOC',
    'Photo Shoot',
    'Accommodation',
  ];

  // Define the images for each service
  const serviceImages = {
     'Spend the Day - Morning': '/images/pool.webp',
        'Spend the Day - Evening': '/images/night.webp',
        'Auvrudu Celebrations': '/images/soecial2.webp',
        'Wedding Events Celebrations': '/images/pree1.webp',
        'Birthday Party Celebrations': '/images/weddd.webp',
        'Special Events Celebrations': '/images/pre1.webp',
        'Co-operate Events': '/images/company.webp',
        'BYOC': '/images/pacl7.webp',
        'Photo Shoot': '/images/room2.webp',
        'Accommodation': '/images/birth23.webp',
  };

  const [selectedServiceIndex, setSelectedServiceIndex] = useState(0);

  // Auto-change the service image every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedServiceIndex((prevIndex) => (prevIndex + 1) % services.length);
    }, 3000); // 3000 ms = 3 seconds

    return () => clearInterval(interval);
  }, [services.length]);

  const selectedService = services[selectedServiceIndex];

  const navigate = useNavigate(); // Initialize useNavigate for navigation

  // Handle button click and navigate to different routes based on service clicked
  const handleRectangleClick = (service) => {
    console.log(`Navigating to ${service}`); // Add this line to check if the service is selected
    if (service === 'Wedding Events Celebrations') {
      navigate('/wedding');
    } else if (service === 'Spend the Day - Morning') {
      navigate('/dayouting');
    } else if (service === 'Spend the Day - Evening') {
      navigate('/dayouting');
    } else if (service === 'Auvrudu Celebrations') {
      navigate('/awrudhu');
    } else if (service === 'Special Events Celebrations') {
      navigate('/special');
    } else if (service === 'Photo Shoot') {
      navigate('/preshoot');
    } else if (service === 'Birthday Party Celebrations') {
      navigate('/special');
    } else if (service === 'Co-operate Events') {
      navigate('/special');
    } else if (service === 'BYOC') {
      navigate('/byoc');
    } else if (service === 'Accommodation') {
      navigate('/accomadation');
    }
  };



  return (
    <section className="service-section" id="services">
      <div className="section-container">
        <h1 className="section-header">OUR SERVICES</h1>

        <div className="service-row">
          {/* First column with the auto-changing image */}
          <div className="service-image-column">
            <img
              src={serviceImages[selectedService]}
            
              className="service-image"
            />
          </div>

          {/* Second column with 6 vertically aligned rectangles for services */}
          <div className="service-rectangles-column">
            {services.map((service, index) => (
              <button
                key={index}
                className={`service-rectangle ${selectedServiceIndex === index ? 'active' : ''}`}
                onClick={() => handleRectangleClick(service)} // Add onClick handler
              >
                {service}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Service1;
